var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import di from "../../../di/serviceLocator";
import { upiExp } from "@frameworks/web/utils/regex";
export var upiinputfield = {
    upi: "",
};
var EditUpiPopup = function (props) {
    var _a, _b;
    var _c = __read(useState((_a = props === null || props === void 0 ? void 0 : props.editUpi) === null || _a === void 0 ? void 0 : _a.UPI), 2), upiValue = _c[0], setUpiValue = _c[1];
    var _d = __read(useState(false), 2), edited = _d[0], setEdited = _d[1];
    var _e = __read(React.useState(upiinputfield), 2), error = _e[0], setError = _e[1];
    var validationError = function (field, value) {
        var _a;
        setError(__assign(__assign({}, error), (_a = {}, _a[field] = value, _a)));
    };
    var upDateUPI = function () {
        var editPayload = {
            id: props.editUpi.Id,
            acCode: props.editUpi.AcCode,
            upi: upiValue,
            bankAcNo: props.editUpi.BankAcNo,
            bankName: props.editUpi.BankName,
            source: props.editUpi.Source,
            createdBy: props.editUpi.CreatedBy,
            createdDate: props.editUpi.CreatedDate,
            modifyBy: props.editUpi.ModifyBy,
            modifyDate: props.editUpi.ModifyDate,
        };
        di.clients.editUPIdetails([editPayload]);
        props === null || props === void 0 ? void 0 : props.setEditUpiDetailsPopup(false);
        props === null || props === void 0 ? void 0 : props.setUpdateData(true);
    };
    React.useEffect(function () {
        var _a;
        setUpiValue((_a = props === null || props === void 0 ? void 0 : props.editUpi) === null || _a === void 0 ? void 0 : _a.UPI);
    }, [props.editUpi]);
    React.useEffect(function () {
        return function () {
            var _a;
            setUpiValue((_a = props === null || props === void 0 ? void 0 : props.editUpi) === null || _a === void 0 ? void 0 : _a.UPI);
            setError(null);
            setEdited(false);
        };
    }, [props.EditUpiDetailsPopup]);
    console.log("disabled", error, upiValue);
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" }, "UPI ID"),
        React.createElement(InputField, { className: "mgt-10 RobotoM_16_500 txt_blackOne1", placeholderClassName: "", value: upiValue, defaultValue: upiValue, onChange: function (val) {
                setEdited(true);
                setUpiValue(val);
            }, pattern: upiExp, onBlur: function (error, event) {
                if (error.required)
                    validationError(event.target.name, "This field is Required");
                else if (!error.pattern)
                    validationError(event.target.name, "Please enter a valid UPI ID");
                else
                    validationError(event.target.name, "");
            }, errorText: error === null || error === void 0 ? void 0 : error.upi, id: "upi", name: "upi" }),
        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Save", className: "mgt-20 w-100", onClick: upDateUPI, disabled: ((_b = error === null || error === void 0 ? void 0 : error.upi) === null || _b === void 0 ? void 0 : _b.length) > 0 || (upiValue === null || upiValue === void 0 ? void 0 : upiValue.length) <= 0 || !edited })));
};
export default EditUpiPopup;
